import type { FaireProductEntity } from "../../entity_types/product";

export const p_5p98h27jvg: FaireProductEntity = {
  token: "p_5p98h27jvg",
  type: "product",
  name: "Charcuterie Board Ornament",
  brandToken: "b_48a2b17b",
  brandName: "Silk Road Bazaar",
  imageUrl:
    "https://cdn.faire.com/fastly/fa0295b6cb73287ae6a045ffa1f454c7448debd16fec02e82f72441167ffe7da.jpeg",
  galleryImageUrls: [],
  priceDollars: 9,
  description:
    "This felt ornament is beautifully crafted with intricate details. This handmade ornament is great for year-round decor! We work with women artisans in Kyrgyzstan to handcraft products using natural fibers and eco-friendly resources. All details are hand stitched and embroidered.\n\nOur talented artisans work in the remote regions of Kyrgyzstan. We connect with artists who are far from the capitals, have limited market access and have carried on traditional craft culture.\n\n• *Approximately 5-6 inches in length*",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:17.349Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
